export const COURSES = {
  japanese: {
    label: "Japanese",
    flag: "🇯🇵",
    courses: [
      {
        level: "Beginner",
        title: "JLPT N5",
        duration: "3–4 months",
        price: 9800,
        popular: false,
        formLevel: "Beginner",
      },
      {
        level: "Elementary",
        title: "JLPT N4",
        duration: "4–5 months",
        price: 11200,
        popular: false,
        formLevel: "Intermediate",
      },
      {
        level: "Intermediate",
        title: "JLPT N3",
        duration: "4–5 months",
        price: 14500,
        popular: false,
        formLevel: "Advanced",
      },
      {
        level: "Combo",
        title: "JLPT N4 + N5",
        duration: "6–8 months",
        price: 17640,
        popular: true,
        formLevel: "Beginner",
      },
    ],
  },
  german: {
    label: "German",
    flag: "🇩🇪",
    courses: [
      {
        level: "Beginner",
        title: "A1 Level",
        duration: "1.5–2 months",
        price: 8500,
        popular: true,
        formLevel: "Beginner",
      },
      {
        level: "Elementary",
        title: "A2 Level",
        duration: "2–3 months",
        price: 9500,
        popular: false,
        formLevel: "Intermediate",
      },
      {
        level: "Intermediate",
        title: "B1 Level",
        duration: "2–3 months",
        price: 10500,
        popular: false,
        formLevel: "Intermediate",
      },
      {
        level: "Advanced",
        title: "A2+A1 Combo Level",
        duration: "3–4 months",
        price: 15000,
        popular: false,
        formLevel: "Advanced",
      },
    ],
  },
  french: {
    label: "French",
    flag: "🇫🇷",
    courses: [
      {
        level: "Beginner",
        title: "A1 Level",
        duration: "1.5–2 months",
        price: 8500,
        popular: true,
        formLevel: "Beginner",
      },
      {
        level: "Elementary",
        title: "A2 Level",
        duration: "2–3 months",
        price: 9600,
        popular: false,
        formLevel: "Intermediate",
      },
      {
        level: "Intermediate",
        title: "B1 Level",
        duration: "2–3 months",
        price: 10500,
        popular: false,
        formLevel: "Intermediate",
      },
      {
        level: "Advanced",
        title: "A2+A1 Combo Level",
        duration: "3–4 months",
        price: 15500,
        popular: false,
        formLevel: "Advanced",
      },
    ],
  },
  spanish: {
    label: "Spanish",
    flag: "🇪🇸",
    courses: [
      {
        level: "Beginner",
        title: "A1 Level",
        duration: "1.5–2 months",
        price: 8500,
        popular: true,
        formLevel: "Beginner",
      },
      {
        level: "Elementary",
        title: "A2 Level",
        duration: "2–3 months",
        price: 9600,
        popular: false,
        formLevel: "Intermediate",
      },
      {
        level: "Intermediate",
        title: "B1 Level",
        duration: "2–3 months",
        price: 10500,
        popular: false,
        formLevel: "Intermediate",
      },
      {
        level: "Advanced",
        title: "A2+A1 Combo Level",
        duration: "3–4 months",
        price: 15500,
        popular: false,
        formLevel: "Advanced",
      },
    ],
  },
  korean: {
    label: "Korean",
    flag: "🇰🇷",
    courses: [
      {
        level: "Beginner",
        title: "Korean Beginner",
        duration: "3–4 months",
        price: 8750,
        popular: true,
        formLevel: "Beginner",
      },
      {
        level: "Intermediate",
        title: "Korean Intermediate",
        duration: "4–5 months",
        price: 9800,
        popular: false,
        formLevel: "Intermediate",
      },
    ],
  },
  chinese: {
    label: "Chinese",
    flag: "🇨🇳",
    courses: [
      {
        level: "Beginner",
        title: "Chinese Beginner",
        duration: "3–4 months",
        price: 8750,
        popular: true,
        formLevel: "Beginner",
      },
      {
        level: "Intermediate",
        title: "Chinese Intermediate",
        duration: "4–5 months",
        price: 9800,
        popular: false,
        formLevel: "Intermediate",
      },
    ],
  },
};

export const FEATURES = [
  {
    icon: "🎥",
    title: "Live Online Classes",
    description:
      "Interactive live sessions with real-time feedback — learn from anywhere, just like a physical classroom.",
  },
  {
    icon: "🎓",
    title: "Expert Certified Trainers",
    description:
      "Learn from qualified, experienced language instructors who know how to get results fast.",
  },
  {
    icon: "👥",
    title: "Small Batch (Max 10 Students)",
    description:
      "Personal attention in every class. Ask questions, practice speaking, and get individual feedback.",
  },
  {
    icon: "⏰",
    title: "Flexible Timings",
    description:
      "Morning, afternoon, or evening batches — pick a schedule that fits your life and work.",
  },
  {
    icon: "💰",
    title: "Affordable Fees",
    description:
      "Quality language education starting at just ₹4,999 — no hidden costs, no compromises on quality.",
  },
  {
    icon: "💼",
    title: "Career & Job Support",
    description:
      "Guidance on jobs abroad, interview prep, and career pathways powered by your new language skills.",
  },
];

export const STEPS = [
  {
    number: "1",
    title: "Book Free Demo Class",
    description:
      "Fill out the form below and attend a free live demo — experience our teaching style before you commit.",
  },
  {
    number: "2",
    title: "Choose Your Course & Level",
    description:
      "Our counsellor helps you pick the right language and level based on your goals and schedule.",
  },
  {
    number: "3",
    title: "Start Learning & Get Certified",
    description:
      "Join live classes, practice with peers, and earn your certificate upon successful completion.",
  },
];

export const INTEREST_MAP = {
  Japanese: "I want to Learn Japanese",
  German: "I want to Learn German",
  French: "I want to Learn French",
  Korean: "I want to Learn Korean",
};

export const FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScNamc82zH0EVR6CgCcB0WRM-NSm90DeGW2_uGfDK3Oj66wpg/formResponse";
